import React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import axios from "axios";
import { API_URL } from "../../config";
import moment from "moment";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function PlayerBanned() {
  const { accessObject } = useAppContext();

  const [showPrePage, setShowPrePage] = React.useState(10);
  const [loader, setLoader] = React.useState(true);
  const [filteredData, setFilteredData] = React.useState([]);
  // const [changeDeviceType, setChangeDeviceType] = React.useState();
  const [searchEmail, setSearchEmail] = React.useState("");
  const [pageNumber, setPageNumber] = React.useState(1);
  const [recordLength, setRecordLength] = React.useState(10);
  const [totalLength, setTotalLength] = React.useState("");
  const [testPage, setTestPage] = React.useState(false);

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const handleClearFilters = () => {
    setSearchEmail("");
    setPageNumber(1);
    setRecordLength(10);
    setPagination({ start: 0, end: showPrePage });
  };

  React.useEffect(() => {
    getPlayerList();
  }, [pageNumber, recordLength, searchEmail, testPage]);

  const getPlayerList = () => {
    setLoader(true);
    axios
      .post(`${API_URL}/api/admin/player/get-all-banned-player-details`, {
        pageNumber: pageNumber,
        recordLength: recordLength,
        search: searchEmail,
      })
      .then((response) => {
        setLoader(false);

        setFilteredData(response.data.data.playerData);
        setTotalLength(response.data.data?.totalLength);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  return (
    <>
      <div className="content p-3">
        <div className="card shadow-sm border-0" style={{ borderRadius: '12px' }}>
          <div className="pl-4 pr-4 pt-4 pb-2">
            <div className="row align-items-end">
              <div className="col-md-4">
                <label className="small text-muted font-weight-bold mb-1">Search Player</label>
                <div className="position-relative">
                  <i className="fas fa-search text-muted position-absolute" style={{ left: '16px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, fontSize: '0.9rem' }}></i>
                  <input
                    className="form-control premium-search-input"
                    type="text"
                    placeholder="Email And Name ..."
                    value={searchEmail}
                    onChange={(e) => {
                      setPageNumber(1);
                      setRecordLength(10);
                      setSearchEmail(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-md-8 d-flex justify-content-end align-items-end mt-3 mt-md-0">
                <button
                  type="button"
                  className="btn btn-premium-outline"
                  onClick={handleClearFilters}
                >
                  Clear Filter
                </button>
              </div>
            </div>
          </div>
          <div class="card-body" style={{ overflow: "scroll" }}>
            <table id="" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>SrNo</th>
                  <th style={{ textAlign: "center" }}>Date</th>
                  <th style={{ textAlign: "center" }}>Id</th>
                  <th style={{ textAlign: "center" }}>Name</th>
                  <th style={{ textAlign: "center" }}>Email</th>
                  <th style={{ textAlign: "center" }}>Balance</th>
                  <th style={{ textAlign: "center" }}>Status</th>
                </tr>
              </thead>
              {accessObject?.getPlayerList == true ? (
                <>
                  <tbody>
                    {!loader ? (
                      <>
                        {filteredData.length > 0 ? (
                          <>
                            {filteredData?.map((item, index) => {
                              return (
                                <>
                                  <tr key={index}>
                                    <td>
                                      {pageNumber === 1
                                        ? index + 1
                                        : index +
                                          1 +
                                          pageNumber * recordLength -
                                          recordLength}
                                    </td>
                                    <td>
                                      {moment(item.createdAt).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </td>
                                    <td>{item.playerId}</td>
                                    <td>{item.name || "-"}</td>
                                    <td>{item.email || "-"}</td>
                                    <td>
                                      {item.depositeBalance +
                                        item.withdrawBalance +
                                        item.bonusBalance}
                                      {/* {Math.round(item.balance * 100) /
                                              100} */}
                                    </td>
                                    <td>
                                      {item.playerStatus === 0
                                        ? "Active"
                                        : "Banned"}
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                          </>
                        ) : (
                          <EmptyState colSpan={10} />
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </tbody>
                </>
              ) : (
                <>
                  <tr style={{ backgroundColor: "rgba(0,0,0,.05)" }}>
                    <td colSpan={8}>
                      <h5 className="text-center">Access Denied</h5>
                    </td>
                  </tr>
                </>
              )}
            </table>
            {accessObject?.getPlayerList == true && (
              <div className="mt-4">{loader && <Loader />}</div>
            )}
          </div>
          {accessObject?.getPlayerList == true && filteredData.length != 0 && (
            <div>
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={filteredData.length}
                paginationTypeApi={true}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                recordLength={recordLength}
                setRecordLength={setRecordLength}
                totalLength={totalLength}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
